import React, { useContext } from 'react'
import { FileContext } from '../Context'
import Applicants from './Applicants'
import Steppers from './Steppers'
import MobileTopBar from './MobileTopBar'

const SideBar: React.FC = (): React.ReactElement => {
  const _ = useContext(FileContext)
  return (
    <>
      <MobileTopBar />
      <Applicants />
      <Steppers />
    </>
  )
}

export default SideBar
